import { ref, computed } from 'vue'

import { useRequestAPIResult } from '@/modules/shared/composables'
import {
  requestLatestEarningsCallBrief,
  requestEarningsCallBriefById,
} from '@/api/earnings_calls'

export default function useGetEarningsCallData({
  ticker = ref(null), fields = ref([]), earningsCallId = ref(undefined),
}) {
  const path = ref(null)
  const fiscalYear = ref(null)
  const fiscalQuarter = ref(null)
  const date = ref(null)
  const previewContent = ref(null)
  const epsReported = ref(null)
  const epsEstimate = ref(null)
  const epsReportedLastYear = ref(null)
  const epsReportedLastQuarter = ref(null)

  const requestAPIFunc = computed(() => {
    if (earningsCallId.value !== undefined) {
      return () => requestEarningsCallBriefById({ id: earningsCallId.value, fields: fields.value })
    }
    return () => requestLatestEarningsCallBrief({ ticker: ticker.value, fields: fields.value })
  })

  const {
    result, isLoading,
    hasLoadingError, requestAPIData,
  } = useRequestAPIResult({
    requestAPI: requestAPIFunc.value,
  })

  const getLatestEarningsCallData = async () => {
    if (isLoading.value) return

    await requestAPIData()
    const { data } = result.value

    if (Object.prototype.hasOwnProperty.call(data, 'path')) path.value = data.path
    if (Object.prototype.hasOwnProperty.call(data, 'fiscal_year')) fiscalYear.value = data.fiscal_year
    if (Object.prototype.hasOwnProperty.call(data, 'fiscal_quarter')) fiscalQuarter.value = data.fiscal_quarter
    if (Object.prototype.hasOwnProperty.call(data, 'date')) date.value = data.date
    if (Object.prototype.hasOwnProperty.call(data, 'preview_content')) previewContent.value = data.preview_content
    if (Object.prototype.hasOwnProperty.call(data, 'eps')) {
      epsReported.value = data.eps.reported
      epsEstimate.value = data.eps.estimate
      epsReportedLastYear.value = data.eps.reported_last_year
      epsReportedLastQuarter.value = data.eps.reported_last_quarter
    }
  }

  return {
    path,
    fiscalYear,
    fiscalQuarter,
    date,
    previewContent,
    epsReported,
    epsEstimate,
    epsReportedLastYear,
    epsReportedLastQuarter,
    isLoading,
    hasLoadingError,
    getLatestEarningsCallData,
  }
}
